module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAQCAYAAACxxengAAAAAXNSR0IArs4c6QAAAItJREFUWEft2M0NgCAMBeB2VCdwBHEEJ3BUjZhISPlp8UYfVwiHD0Leg+nPOI+N6ApEHGhZd7HVRPM87DQRguaQx6CcIT2XyQ7lEMkO5RTJBuUYSQ/lHEkHBaQYDNqPOZC+9FSHAlIWMctQQBI5XEIBqVhWciggVRtdggJSs/a+UEDq/g0wkLpGccENfQl+3qNccAcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/safe_right.png
// module id = 343
// module chunks = 0